import React from "react";
import ReactDOM from "react-dom";
// import "bootstrap/dist/css/bootstrap.css";
import App from "./components/app";
import "./style.css";

ReactDOM.render(<App />, document.getElementById("root"));